<template>
  <div>

    <v-card class="folder-card pb-1 pt-2" :class="cardColorClass" outlined @click="openFile">
      <!-- Encabezado: nombre + menú -->
      <div class="d-flex justify-space-between align-center">
        <p class="font-weight-bold text-body-1 mb-0 truncate-text">{{ file.name }}</p>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="grey--text text--darken-2" v-bind="attrs" v-on="on" @click.stop>
              mdi-dots-vertical
            </v-icon>
          </template>

          <v-list>
            <v-list-item @click="viewInfo">
              <v-list-item-title>Información</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openFile">
              <v-list-item-title>Descargar</v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="$emit('deleteItemFile', file)">
              <v-list-item-title class="red--text">Eliminar</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <!-- Imagen preview o ícono -->
      <v-card-text v-if="isImage" class="pa-0 pt-1">
        <v-img :src="file.path" height="127px" contain style="object-fit: cover; width: 100%;"></v-img>
      </v-card-text>
      <v-card-text v-else class="text-center justify-center align-center d-flex pa-0" style="height: 100%;">
        <v-icon class="mb-1 icon-file" large :color="iconColor" style="height: 127px;">
          {{ fileIcon }}
        </v-icon>
      </v-card-text>
      <v-card-actions class="d-flex pa-0 pt-1">
        <div class="d-flex align-center">
          <span class="text-body-2 grey--text me-2">{{ (file.user_name) }}</span>
          <span class="text-body-2 grey--text">{{ formatUtils.formatDate(file.creation_date) }}</span>
        </div>

      </v-card-actions>
    </v-card>
    <v-dialog v-model="view_info" max-width="500">
      <v-card>
        <v-card-title class="headline">Información del archivo</v-card-title>
        <v-card-text class="mt-5">
          <p><strong>Usuario:</strong> {{ file.user_name }}</p>
          <p><strong>Fecha de creación:</strong> {{ formatUtils.formatDateString(file.creation_date) }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="view_info = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { formatUtils } from "@/libs/utils/formatUtils";
export default {
  name: "CardFile",
  props: {
    file: Object,
  },
  data() {
    return {
      formatUtils: formatUtils,
      view_info: false,

    };
  },
  methods: {
    viewInfo() {
      this.view_info = true;
    },
    openFile() {
      if (this.file?.path) {
        window.open(this.file.path, '_blank');
      }
    },
  },
  computed: {
    extension() {
      if (!this.file?.name) return null;
      const parts = this.file.name.toLowerCase().split(".");
      return parts.length > 1 ? parts.pop() : null;
    },
    isImage() {
      return ["jpg", "jpeg", "png"].includes(this.extension);
    },
    isPdf() {
      return this.extension === "pdf";
    },
    fileIcon() {
      switch (this.extension) {
        case "pdf":
          return "mdi-file-pdf-box";
        case "doc":
        case "docx":
          return "mdi-file-word";
        case "xls":
        case "xlsx":
          return "mdi-file-excel";
        default:
          return "mdi-file-document-outline";
      }
    },
    iconColor() {
      switch (this.extension) {
        case "pdf":
          return "red";
        case "doc":
        case "docx":
          return "blue";
        case "xls":
        case "xlsx":
          return "green";
        default:
          return "grey";
      }
    },
    cardColorClass() {
      switch (this.extension) {
        case "pdf":
          return "border-red lighten-4";
        case "doc":
        case "docx":
          return "border-blue lighten-4";
        case "xls":
        case "xlsx":
          return "border-green lighten-4";
        case "jpg":
        case "jpeg":
        case "png":
          return "border-grey lighten-4";
        default:
          return "border-grey lighten-4";
      }
    },
  },
};
</script>

<style scoped></style>
